import { Outlet, useParams } from 'react-router'
import RouteTabs from '@/components/common/RouteTabs'
import type { RouteTabItem } from '@/components/common/RouteTabs'

export default function ContentLayout() {
  const { clientId } = useParams<{ clientId: string }>()
  if (!clientId) return null

  const base = `/workspace/clients/${clientId}`
  const tabs: RouteTabItem[] = [
    { label: 'Campaigns', href: `${base}/campaigns` },
    { label: 'History', href: `${base}/history` },
  ]

  return (
    <RouteTabs tabs={tabs}>
      <Outlet />
    </RouteTabs>
  )
}
